module.exports = __webpack_public_path__ + "img/prefa.f799eff5.jpg";